/* ============================================================
   SAMANÁ — Gráfico del espectro (blog técnico)
   ------------------------------------------------------------
   El gráfico YA VIENE DIBUJADO desde Liquid (los caminos del SVG se calculan
   en el servidor). Este archivo solo agrega lo interactivo:
     · las píldoras de la leyenda encienden y apagan cada curva;
     · al pasar el dedo o el mouse por el gráfico aparece una guía vertical y
       se lee cuánta luz deja pasar cada cristal en esa longitud de onda.
   Si este archivo no carga, el gráfico se sigue viendo perfecto: solo pierde
   la interacción.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    var svg = root.querySelector('[data-graf-svg]');
    if (!svg) return;

    var series = Array.prototype.slice.call(root.querySelectorAll('[data-serie]'));
    if (!series.length) return;

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-graf-chip]'));
    var vals = Array.prototype.slice.call(root.querySelectorAll('[data-graf-val]'));
    var nmOut = root.querySelector('[data-graf-nm]');
    var cursorG = root.querySelector('[data-graf-cursor]');
    var cursorLine = cursorG ? cursorG.querySelector('line') : null;
    var markersG = root.querySelector('[data-graf-markers]');

    /* Geometría, tal como la escribió Liquid en el SVG */
    var X0 = parseFloat(svg.getAttribute('data-x0'));
    var KX = parseFloat(svg.getAttribute('data-kx'));
    var Y0 = parseFloat(svg.getAttribute('data-y0'));
    var KY = parseFloat(svg.getAttribute('data-ky'));
    var NM_MIN = parseFloat(svg.getAttribute('data-nm-min'));
    var NM_MAX = parseFloat(svg.getAttribute('data-nm-max'));
    var NM_DEF = parseFloat(svg.getAttribute('data-nm-default')) || 480;

    /* El ancho y el origen del lienzo se leen del propio viewBox: el SVG arranca
       en un x negativo para dejarle lugar a la etiqueta del eje vertical, y si
       algún día se vuelve a mover, esto sigue funcionando solo. */
    var vb = (svg.getAttribute('viewBox') || '0 0 760 400').split(/[\s,]+/);
    var VB_X = parseFloat(vb[0]);
    var VB_W = parseFloat(vb[2]);
    if (isNaN(VB_X)) VB_X = 0;
    if (isNaN(VB_W) || !VB_W) VB_W = 760;

    /* Datos de cada curva */
    var datos = series.map(function (g) {
      var lista = (g.getAttribute('data-vals') || '').split(',').map(parseFloat);
      return {
        el: g,
        desde: parseFloat(g.getAttribute('data-desde')),
        paso: parseFloat(g.getAttribute('data-paso')),
        v: lista,
        apagada: false
      };
    });

    /* Marcadores: un círculo por curva, creados una sola vez */
    var NS = 'http://www.w3.org/2000/svg';
    var markers = datos.map(function (d, i) {
      var c = document.createElementNS(NS, 'circle');
      c.setAttribute('r', '4.5');
      c.setAttribute('class', 'sm-bt-graf__marker');
      c.setAttribute('fill', series[i].getAttribute('data-color') || '#000');
      c.setAttribute('visibility', 'hidden');
      if (markersG) markersG.appendChild(c);
      return c;
    });

    function xDe(nm) { return X0 + (nm - NM_MIN) * KX; }
    function yDe(pct) { return Y0 - pct * KY; }

    /* Valor de una curva en una longitud de onda, interpolando entre las dos
       mediciones más cercanas del reporte. */
    function valorEn(d, nm) {
      var pos = (nm - d.desde) / d.paso;
      if (pos <= 0) return d.v[0];
      if (pos >= d.v.length - 1) return d.v[d.v.length - 1];
      var i = Math.floor(pos);
      var f = pos - i;
      var a = d.v[i];
      var b = d.v[i + 1];
      if (isNaN(a) || isNaN(b)) return isNaN(a) ? b : a;
      return a + (b - a) * f;
    }

    function formato(p) {
      if (isNaN(p)) return '—';
      if (p >= 10) return p.toFixed(0) + '%';
      if (p >= 1) return p.toFixed(1) + '%';
      return p.toFixed(2) + '%';
    }

    /* Pinta la lectura para una longitud de onda dada */
    function leer(nm, conGuia) {
      if (nmOut) {
        var chico = nmOut.querySelector('small');
        nmOut.textContent = nm + ' nm';
        if (chico) nmOut.appendChild(chico);
      }

      datos.forEach(function (d, i) {
        var p = valorEn(d, nm);
        var salida = vals[i] ? vals[i].querySelector('[data-graf-out]') : null;
        if (salida) salida.textContent = formato(p);

        if (conGuia && !d.apagada && !isNaN(p)) {
          markers[i].setAttribute('cx', xDe(nm).toFixed(1));
          markers[i].setAttribute('cy', yDe(p).toFixed(1));
          markers[i].setAttribute('visibility', 'visible');
        } else {
          markers[i].setAttribute('visibility', 'hidden');
        }
      });

      if (cursorG && cursorLine) {
        if (conGuia) {
          var x = xDe(nm).toFixed(1);
          cursorLine.setAttribute('x1', x);
          cursorLine.setAttribute('x2', x);
          cursorG.removeAttribute('hidden');
        } else {
          cursorG.setAttribute('hidden', '');
        }
      }
    }

    /* De la posición del dedo/mouse a una longitud de onda, redondeada a 5nm
       (que es el paso real con el que se midieron los cristales). */
    function nmDelEvento(ev) {
      var r = svg.getBoundingClientRect();
      if (!r.width) return null;
      var xUser = VB_X + ((ev.clientX - r.left) / r.width) * VB_W;
      var nm = NM_MIN + (xUser - X0) / KX;
      nm = Math.round(nm / 5) * 5;
      return Math.max(NM_MIN, Math.min(NM_MAX, nm));
    }

    function mover(ev) {
      var nm = nmDelEvento(ev);
      if (nm === null) return;
      leer(nm, true);
    }

    svg.addEventListener('pointermove', mover);
    svg.addEventListener('pointerdown', function (ev) {
      /* En el celular, arrastrar sobre el gráfico mueve la lectura en vez de
         desplazar la página. */
      if (ev.pointerType === 'touch' && svg.setPointerCapture) {
        try { svg.setPointerCapture(ev.pointerId); } catch (e) { /* nada */ }
      }
      mover(ev);
    });
    svg.addEventListener('pointerleave', function () { leer(NM_DEF, false); });
    svg.addEventListener('pointercancel', function () { leer(NM_DEF, false); });

    /* Encender y apagar curvas desde la leyenda */
    chips.forEach(function (chip, i) {
      chip.addEventListener('click', function () {
        var encendida = chip.getAttribute('aria-pressed') === 'true';
        var apagar = encendida;

        /* No dejamos apagar la última curva encendida: el gráfico quedaría vacío. */
        if (apagar) {
          var quedan = datos.filter(function (d, j) { return j !== i && !d.apagada; });
          if (!quedan.length) return;
        }

        datos[i].apagada = apagar;
        chip.setAttribute('aria-pressed', apagar ? 'false' : 'true');
        series[i].setAttribute('data-off', apagar ? 'true' : 'false');
        if (vals[i]) vals[i].setAttribute('data-off', apagar ? 'true' : 'false');
        if (apagar) markers[i].setAttribute('visibility', 'hidden');
      });
    });

    /* Estado inicial: los valores en la longitud de onda elegida, sin guía */
    leer(NM_DEF, false);
  }

  function arrancar() {
    var roots = document.querySelectorAll('[data-sm-espectro]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* El editor de Shopify recarga secciones sueltas sin refrescar la página */
  document.addEventListener('shopify:section:load', function (e) {
    var roots = e.target.querySelectorAll ? e.target.querySelectorAll('[data-sm-espectro]') : [];
    Array.prototype.forEach.call(roots, init);
  });
})();
